import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Checkbox from "../../common/Checkbox";
import Pagination from "../../common/TablePagination";
import closeIcon from "../../../Assets/Icons/popupCloseIcon.svg";
import whiteTick from "../../../Assets/Icons/White Tick.svg";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedWhiteBox.svg";
import { ReactComponent as UncheckedGreyIcon } from "../../../Assets/Icons/unCheckedGreyIcon.svg";
import Loader from "../../common/Loader";
import DetailsPopup from "../../common/DetailsPopup";
import infoIcon from "../../../Assets/Icons/infoIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../../common/SearchBar";
import debounce from "lodash.debounce";
import { Dropdown, Drawer } from "antd";
import FilterPanel from "../../common/FilterPanel";
import DetailsModal from "../../common/DetailsModal";
import RejectOfferPopup from "../../common/RejectOfferPopup";
import crossIcon from "../../../Assets/Icons/cross.svg";
import AddNewLocation from "../../common/OfferForm/Location/AddNewLocation";
import UploadCSVDrawer from "../../common/OfferForm/Location/UploadCSVDrawer";
import { ReactComponent as BackArrow } from "../../../Assets/Icons/backWhiteIcon.svg";
import { addFranchise } from "../../../services/franchiseService";
import toast from "../../../utils/toast";
import "../../common/OfferForm/offerform.scss";
import {
  getMerchants,
  toggleMerchantStatus,
  getMerchantById,
  approveOrRejectMerchant,
  deleteMerchantById,
} from "../../../services/merchantService";
import { getNonDraftedOffers } from "../../../services/offerService";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import PopupContent from "../../Fundraiser/FundraiserReferralListTable/PopupContent";
import CancelPopup from "../../common/CancelPopup";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Confirmation from "../../common/OfferList/Confirmation";
import AddIcon from "../../../Assets/Icons/AddIcon.svg";
import FilterButton from "../../common/FilterButton";
import ChangeLogoModal from "./ChangeLogoModal";
import EditMerchantModal from "./EditMerchantModal";
import TableEmptyState from "../../common/TableEmptyState";

// Remove RangePicker and use DatePicker instead for better fit
// const { RangePicker } = DatePicker;

const AdminMerchantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.merchantReducer?.loading);
  const fundraiserLoading = useSelector(
    (state) => state?.fundraiserReducer?.loading
  );

  const [allMerchants, setAllMerchants] = useState();
  const [fullMerchantsList, setFullMerchantsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [clickedOffer, setClickedOffer] = useState(null);
  const [reason, setReason] = useState("");
  const [infoClicked, setInfoClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [statusToggled, setStatusToggled] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [openReasonBox, setOpenReasonBox] = useState(false);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [isMerchantDetailOpen, setIsMerchantDetailOpen] = useState(false);
  const [showApprovalConfirm, setShowApprovalConfirm] = useState(false);
  const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [merchantToDelete, setMerchantToDelete] = useState(null);
  const [customDate, setCustomDate] = useState([null, null]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showChangeLogoModal, setShowChangeLogoModal] = useState(false);
  const [merchantForLogoChange, setMerchantForLogoChange] = useState(null);
  const [showEditMerchantModal, setShowEditMerchantModal] = useState(false);
  const [merchantForEdit, setMerchantForEdit] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [targetStatus, setTargetStatus] = useState(null);
  const [offerCount, setOfferCount] = useState(0);
  const [activeMerchantId, setActiveMerchantId] = useState(null);
  const [addClicked, setAddClicked] = useState(false);
  const [csvDrawerOpen, setCsvDrawerOpen] = useState(false);
  const [csvLocations, setCsvLocations] = useState([]);
  const [selectedCsvLocationIds, setSelectedCsvLocationIds] = useState([]);
  const [locationToEdit, setLocationToEdit] = useState(null);
  const [isCsvSubmitting, setIsCsvSubmitting] = useState(false);

  const [filterParams, setFilterParams] = useState({
    status: "approved",
    duration: null,
    startDate: null,
    endDate: null,
  });

  // Add these mappings
  const DURATION_MAP = {
    "Today": "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };

  const [filterData, setFilterData] = useState([
    {
      id: "status",
      title: "Status",
      options: ["Approved", "In-Process", "Declined"],
      defaultValue: "Approved",
      multiSelect: false,
      valueMap: {
        Approved: "approved",
        "In-Process": "in-process",
        Declined: "declined",
      },
    },
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: null,
      multiSelect: false,
      valueMap: DURATION_MAP,
      customContent: (selected) => {
        return selected === "Custom Date" ? (
          <div className="mt-3 flex flex-col gap-2">
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">Start Date</label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="Start Date"
                format="YYYY-MM-DD"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">End Date</label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="End Date"
                format="YYYY-MM-DD"
              />
            </div>
          </div>
        ) : null;
      }
    },
  ]);

  // Fix: Update filterData when customDate changes to avoid stale closures
  useEffect(() => {
    setFilterData((prevData) =>
      prevData.map((filter) => {
        if (filter.id === "duration") {
          return {
            ...filter,
            customContent: (selected) => {
              return selected === "Custom Date" ? (
                <div className="mt-3 flex flex-col gap-2">
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">Start Date</label>
                    <DatePicker
                      value={customDate?.[0]}
                      onChange={(date) => {
                        const newDates = [date, customDate?.[1]];
                        setCustomDate(newDates);
                      }}
                      style={{ width: '100%' }}
                      placeholder="Start Date"
                      format="YYYY-MM-DD"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">End Date</label>
                    <DatePicker
                      value={customDate?.[1]}
                      onChange={(date) => {
                        const newDates = [customDate?.[0], date];
                        setCustomDate(newDates);
                      }}
                      style={{ width: '100%' }}
                      placeholder="End Date"
                      format="YYYY-MM-DD"
                    />
                  </div>
                </div>
              ) : null;
            }
          };
        }
        return filter;
      })
    );
  }, [customDate]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue ?? null;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  // Update the handleSelectionChange function
  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  // Update the handleReset function
  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      status: "approved",
      duration: null,
      startDate: null,
      endDate: null,
    });
    setCustomDate([null, null]);
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
  };

  // When applying filters, you can now access both category ID and subcategory IDs array
  const handleApply = () => {
    // Create a new object for mapped filter parameters with initial values
    const mappedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };

    filterData.forEach((filter) => {
      const selectedValue = selections[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "Custom Date") {
          mappedFilterParams.duration = "CUSTOM";
          // If at least one date is selected, we apply custom filter
          if (customDate && (customDate[0] || customDate[1])) {
            mappedFilterParams.startDate = customDate[0] ? customDate[0].format("YYYY-MM-DD") : null;
            mappedFilterParams.endDate = customDate[1] ? customDate[1].format("YYYY-MM-DD") : null;
          }
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });
    setFilterParams(mappedFilterParams);
    setOpen(false);
    setCurrentPage(1);
  };

  // Handle cancel button click
  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("dropdown-open");
    } else {
      document.body.classList.remove("dropdown-open");
    }

    return () => {
      document.body.classList.remove("dropdown-open");
    };
  }, [open]);

  const items = [
    {
      title: "Merchants",
    },
    {
      title: "Merchant List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Name",
    },
    {
      name: "Date joined",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Address",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const isInProcess = (merchant) => {
    const status = (merchant?.status || "").toLowerCase();
    // A merchant is only considered "In-Process" in the Merchant List if they have actually
    // started their onboarding (has a user account or entered business details).
    // Otherwise, they stay in the Invitation List.
    const hasStarted = !!merchant.userId || !!merchant.user || !!merchant.businessName || !!merchant.business_name;
    const inProcessStatuses = ["pending", "accepted", "completed", "in-process", "in-progress"];

    if (status === "pending" || status === "") {
      return hasStarted;
    }

    return inProcessStatuses.includes(status);
  };

  const updatePageSlice = (data, page) => {
    if (!data) return;
    const startIndex = (page - 1) * 10;
    const endIndex = startIndex + 10;
    setAllMerchants(data.slice(startIndex, endIndex));
  };

  const getMerchantsData = async (silent = false) => {
    try {
      if (silent) setSearching(true);
      let searchParams = {
        limit: 1000,
        status: filterParams.status === 'in-process' ? null : (filterParams.status || null),
        duration: filterParams.duration?.toLowerCase() || null,
        silent: silent,
      };

      // Add custom dates if standard duration is CUSTOM
      if (filterParams.duration === 'CUSTOM') {
        if (filterParams.startDate) searchParams.startDate = filterParams.startDate;
        if (filterParams.endDate) searchParams.endDate = filterParams.endDate;
      }

      // Remove null values to avoid sending empty parameters
      Object.keys(searchParams).forEach((key) =>
        searchParams[key] === null ? delete searchParams[key] : {}
      );

      const response = await dispatch(getMerchants(searchParams))?.unwrap();
      if (response?.success) {
        const rawData = response.data || [];
        // Filter out internal placeholders
        const cleanData = rawData.filter(m => {
          const name = m.businessName || m.business_name || "";
          return typeof name === 'string' && !name.startsWith("Pending_");
        });
        setFullMerchantsList(cleanData);
      }
    } catch (error) {
      console.error("Error in getMerchantsData:", error);
    } finally {
      setSearching(false);
    }
  };

  // 1. Initial/Filter/Status load
  useEffect(() => {
    getMerchantsData();
  }, [statusToggled, filterParams]);

  // Logic to filter and slice data for display
  useEffect(() => {
    if (!fullMerchantsList) return;

    let filtered = [...fullMerchantsList].filter((merchant) =>
      !!merchant.userId ||
      !!merchant.user ||
      (!!merchant.businessName && !merchant.businessName.startsWith("Pending_")) ||
      (!!merchant.business_name && !merchant.business_name.startsWith("Pending_"))
    );

    // Status Filter (local override for 'in-process' and ensuring UI consistency)
    if (filterParams.status) {
      if (filterParams.status === "in-process") {
        filtered = filtered.filter((merchant) => isInProcess(merchant));
      } else if (filterParams.status === "approved") {
        // Show only explicitly approved merchants that are not in-process
        filtered = filtered.filter((merchant) => (merchant?.status || "").toLowerCase() === "approved" && !isInProcess(merchant));
      } else if (filterParams.status === "declined") {
        // Show only declined/rejected merchants
        filtered = filtered.filter((merchant) => {
          const s = (merchant?.status || "").toLowerCase();
          return s === "declined" || s === "rejected";
        });
      } else {
        filtered = filtered.filter(
          (merchant) => (merchant?.status || "").toLowerCase() === filterParams.status
        );
      }
    }

    // Date Filter (Local)
    if (filterParams.duration && filterParams.duration !== "CUSTOM") {
      let start = null;
      let end = dayjs().endOf('day');

      if (filterParams.duration === "DAY") {
        start = dayjs().startOf('day');
      } else if (filterParams.duration === "WEEK") {
        start = dayjs().startOf('week');
      } else if (filterParams.duration === "MONTH") {
        start = dayjs().startOf('month');
      } else if (filterParams.duration === "YEAR") {
        start = dayjs().startOf('year');
      }

      if (start) {
        filtered = filtered.filter((merchant) => {
          const createdAt = merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt;
          if (!createdAt) return false;
          const joinedDate = dayjs(createdAt);
          return joinedDate.isAfter(start) || joinedDate.isSame(start);
        });
      }
    }

    if (filterParams.duration === "CUSTOM" && (filterParams.startDate || filterParams.endDate)) {
      const start = filterParams.startDate ? dayjs(filterParams.startDate).startOf('day') : null;
      const end = filterParams.endDate ? dayjs(filterParams.endDate).endOf('day') : null;

      filtered = filtered.filter((merchant) => {
        const createdAt = merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt;
        if (!createdAt) return false;

        const joinedDate = dayjs(createdAt);
        if (!joinedDate.isValid()) return false;

        let matches = true;
        if (start) matches = matches && (joinedDate.isAfter(start) || joinedDate.isSame(start));
        if (end) matches = matches && (joinedDate.isBefore(end) || joinedDate.isSame(end));
        return matches;
      });
    }

    // Search Filter
    if (searchQuery.trim()) {
      const term = searchQuery.toLowerCase().trim();
      filtered = filtered.filter((merchant) => {
        const businessName = (merchant?.businessName || merchant?.business_name || "").toLowerCase();
        const userEmail = (merchant?.user?.email || "").toLowerCase();
        const merchantEmail = (merchant?.email || "").toLowerCase();
        const contact = (merchant?.contactPersonNumber || merchant?.contact_number || merchant?.phone || merchant?.phoneNumber || "").toLowerCase();
        const address = (merchant?.address || merchant?.location || "").toLowerCase();
        const contactPerson = (merchant?.contactPersonName || merchant?.contactName || merchant?.name || "").toLowerCase();
        const website = (merchant?.website || merchant?.websiteUrl || "").toLowerCase();
        const dateJoined = (separateDateTimeAndConvertToLocale(merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt)?.localDate || "").toLowerCase();

        return (
          businessName.includes(term) ||
          userEmail.includes(term) ||
          merchantEmail.includes(term) ||
          contact.includes(term) ||
          address.includes(term) ||
          contactPerson.includes(term) ||
          website.includes(term) ||
          dateJoined.includes(term)
        );
      });
    }

    // Default Sort: Newest First
    filtered.sort((a, b) => {
      const dateA = dayjs(a?.createdAt || a?.created_at || a?.notifiedAt || 0);
      const dateB = dayjs(b?.createdAt || b?.created_at || b?.notifiedAt || 0);
      return dateB.diff(dateA);
    });

    setCount(filtered.length);
    setTotalPages(Math.ceil(filtered.length / 10) || 1);

    updatePageSlice(filtered, currentPage);
  }, [searchQuery, fullMerchantsList, filterParams.status, filterParams.duration, filterParams.startDate, filterParams.endDate, currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of merchant list when changing pages
    const container = document.getElementById('merchant-list-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // const handleToggle = async (id) => {
  //   try {
  //     const togglePromise = await dispatch(
  //       toggleOfferStatus({ id: id })
  //     ).unwrap();
  //     if (togglePromise?.success === true) {
  //       getOffersData();
  //     }
  //   } catch (error) {
  //     console.error("Error toggling location status:", error);
  //   }
  // };

  const handleCloseInfo = () => {
    setInfoClicked(false);
    setClickedOffer(null);
  };

  const handleInfoClick = (offer) => {
    setClickedOffer(offer);
    setInfoClicked(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchQuery(value);
        setCurrentPage(1);
        setSearching(false);
      }, 500),
    []
  );

  const handleSearchChange = (value) => {
    setSearchInput(value);
    setSearching(true);
    debouncedSearch(value);
  };

  const getSelectableOffers = () => {
    return allMerchants || [];
  };

  const handleSelectAll = () => {
    const selectableOffers = getSelectableOffers();

    if (
      selectableOffers.length > 0 &&
      selected.length === selectableOffers.length
    ) {
      setSelected([]);
    } else {
      const newSelected = selectableOffers.map((offer) => offer._id);
      setSelected(newSelected);
    }
  };

  const handleSelectOne = (event, id, status) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Allow selection for all statuses (Approved/Declined can be moved to Pending)
  const isSelectable = (status) => {
    return true;
  };

  const handleBulkApprove = () => {
    setShowApprovalConfirm(true);
  };

  const handleApproveConfirm = async () => {
    setShowApprovalConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "approved",
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload)
      )?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
      }
    } catch (error) {
      console.error("Error approving offers:", error);
    }
  };

  const handleBulkDecline = () => {
    setShowDeclineConfirm(true);
  };

  const handleDeclineConfirm = async () => {
    setShowDeclineConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "declined",
        reason: "Bulk declined",
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload)
      )?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
      }
    } catch (error) {
      console.error("Error declining offers:", error);
    }
  };

  // Move selected merchants to pending
  const handleBulkPending = async () => {
    try {
      const payload = {
        ids: selected,
        status: "pending",
        reason: "Moved to pending",
      };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
        setShowActionModal(false);
      }
    } catch (error) {
      console.error("Error setting pending merchants:", error);
    }
  };

  // Single approve/decline from detail modal
  const handleApproveSingle = async (id) => {
    try {
      const payload = { ids: [id], status: "approved" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
      }
    } catch (e) {
      console.error("Error approving merchant:", e);
    }
  };

  const handleDeclineSingle = async (id) => {
    try {
      const payload = { ids: [id], status: "declined", reason: "Declined from details" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
      }
    } catch (e) {
      console.error("Error declining merchant:", e);
    }
  };

  const handleReviewStatus = async (merchantId, newStatus) => {
    try {
      const payload = { ids: [merchantId], status: newStatus, reason: "Status reviewed by admin" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
        setShowReviewModal(false);
      }
    } catch (e) {
      console.error("Error reviewing merchant status:", e);
    }
  };

  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setShowReviewModal(false);
  };

  const handleStatusChangeRequest = async (status) => {
    setOfferCount(0); // Reset count immediately
    setTargetStatus(status);
    if (status === 'declined' && merchantDetails?.status?.toLowerCase() === 'approved') {
      try {
        const response = await dispatch(getNonDraftedOffers({
          merchantId: merchantDetails._id,
          status: 'approved',
          limit: 1, // Minimize payload as we just need the count
          silent: true
        })).unwrap();
        if (response?.success) {
          // Thoroughly check for total count in different possible response locations
          const count = response?.total || response?.totalCount || response?.count || (Array.isArray(response?.data) ? response?.data?.length : 0);
          setOfferCount(count);
        }
      } catch (error) {
        console.error("Error fetching merchant offers count:", error);
      }
    }
    setShowStatusConfirm(true);
  };

  const handleStatusConfirm = async () => {
    setShowStatusConfirm(false);
    if (!merchantDetails?._id || !targetStatus) return;

    try {
      const payload = {
        ids: [merchantDetails._id],
        status: targetStatus,
        reason: `Status changed to ${targetStatus} by admin`
      };
      const response = await dispatch(approveOrRejectMerchant(payload)).unwrap();
      if (response?.success) {
        setStatusToggled(!statusToggled);
        // Refresh details modal
        fetchMerchantDetails(merchantDetails._id);
      }
    } catch (error) {
      console.error("Error changing merchant status:", error);
    }
  };

  const handleDeclineCancel = () => {
    setShowDeclineConfirm(false);
  };
  const handleApproveCancel = () => {
    setShowApprovalConfirm(false);
  };

  const handleDeleteMerchant = (id) => {
    setMerchantToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    console.log("handleDeleteConfirm called with merchantToDelete:", merchantToDelete);
    try {
      const deletePromise = await dispatch(
        deleteMerchantById({ id: merchantToDelete })
      )?.unwrap();
      console.log("Delete response:", deletePromise);
      if (deletePromise?.success === true) {
        console.log("Delete successful, closing modal and refreshing data");
        setIsMerchantDetailOpen(false);
        getMerchantsData(searchQuery);
      } else {
        console.log("Delete failed:", deletePromise);
      }
    } catch (error) {
      console.error("Error deleting merchant:", error);
    } finally {
      setShowDeleteConfirm(false);
      setMerchantToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setMerchantToDelete(null);
  };

  useEffect(() => {
    if (selected.length > 0) {
      setShowActionModal(true);
    } else {
      setShowActionModal(false);
    }
  }, [selected]);

  // Calculate count of selectable items for "Select All" checkbox
  const selectableCount = getSelectableOffers().length;
  const allSelectableSelected =
    selectableCount > 0 && selected.length === selectableCount;

  // Determine which bulk action buttons to show based on selected statuses
  const selectedStatuses = selected
    .map((id) => allMerchants?.find((m) => m._id === id)?.status)
    .filter(Boolean)
    .map((s) => s?.toLowerCase());
  const hasPendingSelected = selectedStatuses.includes("pending");
  const hasApprovedDeclinedSelected = selectedStatuses.some(status => status === "approved" || status === "declined");

  // Show approve/decline buttons only if there are pending items selected
  const showApproveDecline = selected.length > 0 && hasPendingSelected;
  // Show move to pending only if there are approved/declined items selected
  const showMoveToPending = selected.length > 0 && hasApprovedDeclinedSelected;

  const handleMerchantDisable = async () => {
    setOpenReasonBox(false);
    const togglePromise = await dispatch(
      toggleMerchantStatus({ id: selectedMerchant?._id, reason: reason })
    ).unwrap();
    if (togglePromise?.success === true) {
      setStatusToggled(!statusToggled);
      setSelectedMerchant(null);
    }
  };

  const handleCloseReject = () => {
    setSelectedMerchant(null);
    setOpenReasonBox(false);
  };

  const fetchMerchantDetails = async (merchantId) => {
    try {
      const merchantDetailsPromise = await dispatch(
        getMerchantById({ id: merchantId, silent: true })
      )?.unwrap();
      if (merchantDetailsPromise?.success === true) {
        setMerchantDetails(merchantDetailsPromise?.data);
      }
    } catch (error) {
      console.error("Error fetching merchant details:", error);
    }
  };

  const openMerchantPopup = (merchantId) => {
    setMerchantDetails(null);
    setIsMerchantDetailOpen(true);
    fetchMerchantDetails(merchantId);
  };

  const closeMerchantPopup = () => {
    setIsMerchantDetailOpen(false);
  };



  const handleOpenChangeLogoModal = (merchant) => {
    setMerchantForLogoChange(merchant);
    // Hide the View Details modal temporarily
    setIsMerchantDetailOpen(false);
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setShowChangeLogoModal(true);
    }, 100);
  };

  const handleCloseChangeLogoModal = () => {
    setShowChangeLogoModal(false);
    setMerchantForLogoChange(null);
    // Show the View Details modal back with animation
    setTimeout(() => {
      setIsMerchantDetailOpen(true);
    }, 100);
  };

  const handleLogoChangeSuccess = () => {
    // Refresh merchant data after logo change
    getMerchantsData(searchQuery);
    // If the details modal was open, refresh the merchant details
    if (merchantDetails?._id) {
      fetchMerchantDetails(merchantDetails._id);
    }
  };

  const handleOpenEditMerchantModal = (merchant) => {
    setMerchantForEdit(merchant);
    setIsMerchantDetailOpen(false);
    setTimeout(() => {
      setShowEditMerchantModal(true);
    }, 100);
  };

  const handleCloseEditMerchantModal = () => {
    setShowEditMerchantModal(false);
    setMerchantForEdit(null);
    setTimeout(() => {
      setIsMerchantDetailOpen(true);
    }, 100);
  };

  const handleEditMerchantSuccess = () => {
    getMerchantsData(searchQuery);
    if (merchantDetails?._id) {
      // Add a slight delay to ensure DB write propagation before refetching
      setTimeout(() => {
        fetchMerchantDetails(merchantDetails._id);
      }, 500);
    }
  };

  const handleSelectCsvLocation = (id) => {
    setSelectedCsvLocationIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleBatchSelectCsvLocations = (locs, isSelected) => {
    if (isSelected) {
      setSelectedCsvLocationIds(locs.map(l => l._id));
    } else {
      setSelectedCsvLocationIds([]);
    }
  };

  const handleCsvConfirm = async () => {
    if (selectedCsvLocationIds.length === 0) {
      toast.error("Please select at least one location.");
      return;
    }

    const selectedLocations = csvLocations.filter(loc => selectedCsvLocationIds.includes(loc._id));
    setIsCsvSubmitting(true);

    try {
      const res = await dispatch(addFranchise({ merchant: activeMerchantId, locations: selectedLocations })).unwrap();
      if (res?.success) {
        toast.success(`${selectedLocations.length} location(s) added successfully`);
        setCsvDrawerOpen(false);
        setCsvLocations([]);
        setSelectedCsvLocationIds([]);
        if (activeMerchantId) {
          setTimeout(() => {
            setIsMerchantDetailOpen(true);
            fetchMerchantDetails(activeMerchantId);
          }, 300);
        }
      }
    } catch (err) {
      console.error("CSV Confirm error:", err);
    } finally {
      setIsCsvSubmitting(false);
    }
  };

  return (
    <>
      {(loading === true || fundraiserLoading === true) && <Loader />}
      {infoClicked === true && (
        <DetailsPopup
          content={clickedOffer?.reason}
          handleClose={handleCloseInfo}
          icon={infoIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      {openReasonBox === true && (
        <RejectOfferPopup
          icon={crossIcon}
          content={
            "Could you please provide the reason for disabling this merchant?"
          }
          popupClassName={"w-[400px] sm:w-[500px] pb-4"}
          handleClose={handleCloseReject}
          setReason={setReason}
          handleOfferRejection={handleMerchantDisable}
        />
      )}
      {isMerchantDetailOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from { transform: translateY(-20px) scale(0.95); opacity: 0; }
                to { transform: translateY(0) scale(1); opacity: 1; }
              }
            `}
          </style>
          <div style={{
            animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <DetailsModal
              handleClose={closeMerchantPopup}
              content={
                <PopupContent
                  merchantDetails={merchantDetails}
                  onDelete={handleDeleteMerchant}
                  onApprove={(id) => handleApproveSingle(id)}
                  onDecline={(id) => handleDeclineSingle(id)}
                  onReviewStatus={handleReviewStatus}
                  onShowReviewModal={handleShowReviewModal}
                  onChangeLogo={handleOpenChangeLogoModal}
                  onEdit={handleOpenEditMerchantModal}
                  onStatusChangeRequest={handleStatusChangeRequest}
                  onAddLocation={() => {
                    setLocationToEdit(null);
                    setActiveMerchantId(merchantDetails?._id);
                    setIsMerchantDetailOpen(false);
                    setTimeout(() => setAddClicked(true), 100);
                  }}
                  onUploadCSV={() => {
                    setCsvLocations([]);
                    setSelectedCsvLocationIds([]);
                    setActiveMerchantId(merchantDetails?._id);
                    setIsMerchantDetailOpen(false);
                    setTimeout(() => setCsvDrawerOpen(true), 100);
                  }}
                  onEditLocation={(store) => {
                    setLocationToEdit(store);
                    setActiveMerchantId(merchantDetails?._id);
                    setIsMerchantDetailOpen(false);
                    setTimeout(() => setAddClicked(true), 100);
                  }}
                />
              }
              popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
            />
          </div>
        </div>
      )}
      {showApprovalConfirm && (
        <CancelPopup
          handleNo={handleApproveCancel}
          handleYes={handleApproveConfirm}
          heading="Approve Offers"
          content="Do you really want to approve all selected offers?"
          confirmation={true}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showDeclineConfirm && (
        <CancelPopup
          handleNo={handleDeclineCancel}
          handleYes={handleDeclineConfirm}
          heading="Decline Offers"
          content="Do you really want to decline all selected offers?"
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showStatusConfirm && (
        <CancelPopup
          handleNo={() => setShowStatusConfirm(false)}
          handleYes={handleStatusConfirm}
          heading="Change Status"
          content={
            targetStatus === 'declined' && merchantDetails?.status?.toLowerCase() === 'approved' && offerCount > 0
              ? `Are you sure you want to decline this merchant? By moving to "Declined", ${offerCount} live offer${offerCount > 1 ? 's' : ''} of this merchant will be removed from the App.`
              : `Are you sure you want to change this merchant status to "${targetStatus === 'approved' ? 'Approved' : 'Declined'}"?`
          }
          confirmation={targetStatus === 'approved'}
          popupClassName="w-[300px] sm:w-[420px] h-[240px] sm:h-[230px]"
        />
      )}
      {showDeleteConfirm && (
        <CancelPopup
          handleNo={handleDeleteCancel}
          handleYes={handleDeleteConfirm}
          heading="Delete Merchant"
          content="Are you sure you want to delete this merchant profile? This action cannot be undone."
          image={deleteImg}
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showChangeLogoModal && merchantForLogoChange && (
        <ChangeLogoModal
          merchantDetails={merchantForLogoChange}
          onClose={handleCloseChangeLogoModal}
          onSuccess={handleLogoChangeSuccess}
        />
      )}
      {showEditMerchantModal && merchantForEdit && (
        <EditMerchantModal
          merchantDetails={merchantForEdit}
          onClose={handleCloseEditMerchantModal}
          onSuccess={handleEditMerchantSuccess}
        />
      )}
      <div className="flex flex-col sm:flex-row justify-between col-span-12 gap-4">
        <BreadCrumsHeader heading="Merchant List" items={items} />
        <div className="flex gap-3 items-center">
          {/* In-Progress Merchants button removed as per request to merge lists */}
        </div>
      </div>
      <div className="w-full flex justify-between items-center mt-6 gap-3">
        <SearchBar
          parentDivClass="w-full sm:w-[60%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative w-full"
          inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px]"
          placeholder="Search"
          value={searchInput}
          handleChange={(e) => handleSearchChange(e.target.value)}
          onClear={() => handleSearchChange("")}
          loading={searching}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "280px",
            width: "max-content",
            maxWidth: "90vw",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <FilterButton isOpen={open} />
        </Dropdown>
      </div>
      <div id="merchant-list-container" className="col-span-12 mt-4">
        {/* Desktop Table View */}
        <TableContainer style={{ width: "100%", overflowX: "auto" }} className="hidden md:block">
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns
                  .filter((column) => !(filterParams.status === "in-process" && column.name === "Actions"))
                  .map((column) => {
                    return (
                      <TableCell key={column.name} className="!text-[#FFFFFF]">
                        {column.name}
                      </TableCell>
                    );
                  })}
              </TableRow>
            </TableHead>

            <TableBody>
              {allMerchants && allMerchants?.length > 0 &&
                allMerchants?.map((merchant, index) => {
                  const isItemSelected = isSelected(merchant._id);
                  const itemSelectable = isSelectable(merchant.status);
                  return (
                    <TableRow
                      key={merchant._id}
                      className="h-[50px]"
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor:
                          (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                      }}
                    >
                      <TableCell className="max-w-[50px]">{(currentPage - 1) * 50 + index + 1}</TableCell>
                      <TableCell
                        title={merchant?.businessName}
                        className="max-w-[120px] truncate"
                      >
                        {merchant?.businessName || "N/A"}
                      </TableCell>
                      <TableCell
                        title={merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt}
                        className="max-w-[120px] truncate"
                      >
                        {
                          separateDateTimeAndConvertToLocale(merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt)
                            ?.localDate || "N/A"
                        }
                      </TableCell>
                      <TableCell
                        title={merchant?.user?.email || merchant?.email}
                        className="max-w-[140px] truncate"
                      >
                        {merchant?.user?.email || merchant?.email || "N/A"}
                      </TableCell>
                      <TableCell
                        title={merchant?.contactPersonNumber}
                        className="max-w-[120px] truncate"
                      >
                        {merchant?.contactPersonNumber || "N/A"}
                      </TableCell>
                      <TableCell
                        title={merchant?.address}
                        className="max-w-[180px] truncate"
                      >
                        {merchant?.address || "N/A"}
                      </TableCell>
                      <TableCell className="max-w-[110px]">
                        <Confirmation
                          status={
                            (merchant?.status || "").toLowerCase() === "declined" || (merchant?.status || "").toLowerCase() === "rejected"
                              ? "declined"
                              : isInProcess(merchant)
                                ? "in-process"
                                : "approved"
                          }
                          handleInfoClick={() => handleInfoClick(merchant)}
                          creatorRole="merchant"
                        />
                      </TableCell>
                      {filterParams.status !== "in-process" && (
                        <TableCell className="max-w-[130px]">
                          {!isInProcess(merchant) && (
                            <button
                              className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                              onClick={() => openMerchantPopup(merchant?._id)}
                            >
                              <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                                View Details
                              </span>
                            </button>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}

              {!loading && !searching && allMerchants && allMerchants.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={columns.filter((column) => !(filterParams.status === "in-process" && column.name === "Actions")).length}
                    align="center"
                    className="!border-b-0 !p-0"
                  >
                    <TableEmptyState itemName="Merchant" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile Card View */}
        <div className="block md:hidden space-y-4">
          {allMerchants && allMerchants?.length > 0 &&
            allMerchants?.map((merchant, index) => (
              <div
                key={merchant._id}
                className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-[16px] font-[600] text-[#303030] font-poppins truncate max-w-[200px]">
                      {merchant?.businessName || "N/A"}
                    </h3>
                    <p className="text-[12px] font-[400] text-[#767676] font-poppins">
                      {merchant?.user?.email || merchant?.email || "N/A"}
                    </p>
                  </div>
                  <Confirmation
                    status={
                      (merchant?.status || "").toLowerCase() === "declined" || (merchant?.status || "").toLowerCase() === "rejected"
                        ? "declined"
                        : isInProcess(merchant)
                          ? "in-process"
                          : "approved"
                    }
                    handleInfoClick={() => handleInfoClick(merchant)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-2 text-[13px] font-poppins text-[#303030]">
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Joined Date</span>
                    <span className="truncate">
                      {separateDateTimeAndConvertToLocale(merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt)?.localDate || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Contact</span>
                    <span className="truncate">{merchant?.contactPersonNumber || "N/A"}</span>
                  </div>
                  <div className="flex flex-col col-span-2 mt-1">
                    <span className="text-[#8C8C8C] text-[11px]">Address</span>
                    <span className="truncate">
                      {merchant?.address || "N/A"}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-2">
                  {!isInProcess(merchant) && (
                    <button
                      className="flex-1 flex justify-center items-center border border-[#00ADEF] rounded-[6px] py-2 bg-[#F0FBFF] hover:bg-[#E0F7FA] transition-colors"
                      onClick={() => openMerchantPopup(merchant?._id)}
                    >
                      <span className="font-[600] text-[13px] text-[#00ADEF] font-poppins">
                        View Details
                      </span>
                    </button>
                  )}
                </div>
              </div>
            ))
          }
          {!loading && !searching && (!allMerchants || allMerchants.length === 0) && (
            <TableEmptyState itemName="Merchant" />
          )}
        </div>

        {allMerchants && allMerchants.length > 0 && (
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}

        {/* {showActionModal && (
          <div
            className="fixed bottom-16 left-[57%] transform -translate-x-1/2 bg-white rounded-[6px] px-4 h-[60px] flex items-center gap-4 z-50 text-[14px] font-[600] text-[#303030] border border-[#0000001A]"
            style={{ boxShadow: "0px 4px 20px 0px #00000029" }}
          >
            <div className="flex items-center gap-2">
              <span className="!text-[12px] !font-[500] !text-[#000000] border border-[#2A35484D] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center">
                {selected.length}
              </span>
              <span className="!font-[500]">Selected</span>
            </div>
            <div className="flex items-center gap-16">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedGreyIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                  <span className="whitespace-nowrap !font-[500]">
                    Select All
                  </span>
                </div>
                {showApproveDecline && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className="bg-[#00ADEF] text-white h-[38px] whitespace-nowrap pl-4 pr-8 py-1 rounded-[6px] flex items-center gap-2"
                    >
                      <img
                        src={whiteTick}
                        alt="tick"
                        className="h-[16px] w-[16px]"
                      />
                      Approve Merchants
                    </button>
                    <button
                      onClick={handleBulkDecline}
                      className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                    >
                      Decline Merchants
                    </button>
                  </>
                )}
                {showMoveToPending && (
                  <button
                    onClick={handleBulkPending}
                    className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                  >
                    Move to Pending
                  </button>
                )}
              </div>
              <button
                onClick={() => setSelected([])}
                className="w-[10px] h-[10px]"
              >
                <img src={closeIcon} alt="Close" className="w-full h-full" />
              </button>
            </div>
          </div>
        )} */}

        {/* Review Status Modal */}
        {/* {showReviewModal && (
          <div className="popup-container" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl border border-[#00ADEF]">
              <h3 className="text-lg font-semibold mb-4 text-center">Review Status</h3>
              <p className="text-gray-600 mb-6 text-center">
                Are you sure you want to change the status from{" "}
                <span className="font-semibold capitalize">{merchantDetails?.status}</span> to{" "}
                <span className="font-semibold">Pending</span>?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleCloseReviewModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleReviewStatus(merchantDetails?._id, "pending")}
                  className="flex-1 px-4 py-2 bg-[#00ADEF] text-white rounded-md hover:bg-[#0088CC]"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div >
      {/* Add Location Drawer */}
      <Drawer
        placement="right"
        onClose={() => {
          setAddClicked(false);
          setLocationToEdit(null);
          setIsMerchantDetailOpen(true);
        }}
        open={addClicked}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer add-location-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: "none" }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div className="close-icon-wrapper" onClick={() => {
            setAddClicked(false);
            setLocationToEdit(null);
            setIsMerchantDetailOpen(true);
          }}>
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">
              {locationToEdit ? "Edit Store Location for " : "Add New Store Location for "}
              <span className="text-[#00ADEF]">{merchantDetails?.businessName}</span>
            </h2>
            <p className="drawer-subtitle">
              {locationToEdit ? "Update the details for this store location." : "Fill in the required details to create a new store location."}
            </p>
          </div>
        </div>
        <AddNewLocation
          allStores={false}
          setLocations={() => { }}
          setSelectedLocations={() => { }}
          setSelectedLocationIds={() => { }}
          setLocationNames={() => { }}
          selectedMerchant={merchantDetails}
          editData={locationToEdit}
          onSuccess={() => {
            setAddClicked(false);
            setLocationToEdit(null);
            if (activeMerchantId) {
              setTimeout(() => {
                setIsMerchantDetailOpen(true);
                fetchMerchantDetails(activeMerchantId);
              }, 300);
            }
          }}
          isDrawer={true}
        />
      </Drawer>

      {/* Upload CSV Drawer */}
      <Drawer
        placement="right"
        onClose={() => {
          setCsvDrawerOpen(false);
          setIsMerchantDetailOpen(true);
        }}
        open={csvDrawerOpen}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer csv-upload-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: "none" }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div className="close-icon-wrapper" onClick={() => {
            setCsvDrawerOpen(false);
            setIsMerchantDetailOpen(true);
          }}>
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">
              Upload Locations via CSV for <span className="text-[#00ADEF]">{merchantDetails?.businessName}</span>
            </h2>
            <p className="drawer-subtitle">
              Quickly add multiple store locations by uploading a CSV file.
            </p>
          </div>
        </div>
        <UploadCSVDrawer
          onClose={() => {
            setCsvDrawerOpen(false);
            setCsvLocations([]);
            setSelectedCsvLocationIds([]);
            setIsMerchantDetailOpen(true);
          }}
          csvLocations={csvLocations}
          selectedLocationIds={selectedCsvLocationIds}
          onSelectionChange={handleSelectCsvLocation}
          onBatchSelectionChange={handleBatchSelectCsvLocations}
          onConfirm={handleCsvConfirm}
          isSubmitting={isCsvSubmitting}
          onClear={() => {
            setCsvLocations([]);
            setSelectedCsvLocationIds([]);
          }}
          onUploadSuccess={(event) => {
            const file = event?.target?.files?.[0];
            if (!file) return;
            const isCSV = file.name.toLowerCase().endsWith(".csv");
            if (!isCSV) { toast.error("Only .csv files are allowed!"); return; }
            const reader = new FileReader();
            reader.onload = (e) => {
              const text = e.target.result;
              const lines = text.split(/\r?\n/).filter((l) => l.trim() !== "");
              if (lines.length < 2) { toast.error("CSV must have headers and at least one row."); return; }
              const splitLine = (line) => { const m = line.trim().match(/("[^"]*"|[^,]+)(?=,|$)/g); return m ? m.map((x) => x.replace(/^"|"$/g, "").trim()) : []; };
              const headers = splitLine(lines[0]).map((h) => h.toLowerCase().replace(/\r/g, ""));
              const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
              const data = lines.slice(1).map((line, idx) => {
                const vals = splitLine(line).map((v) => v.replace(/\r/g, ""));
                const row = {};
                headers.forEach((k, i) => { row[k] = vals[i] || ""; });
                const tradingHours = days.map((day) => ({ day, openTime: row[`${day}_open`] || "", closeTime: row[`${day}_close`] || "" }));
                return { name: row["name"] || "", email: row["email"] || "", phone: String(row["phone"] || "").replace(/\D/g, ""), address: row["address"] || "", tradingHours, googlePlaceId: row["googleplaceid"] || null, _id: `temp_${Date.now()}_${idx}` };
              }).filter((r) => r.name && (r.address || r.googlePlaceId));
              if (data.length > 0) {
                setCsvLocations(data);
                setSelectedCsvLocationIds(data.map(d => d._id));
                toast.success(`${data.length} locations parsed from CSV.`);
              }
            };
            reader.readAsText(file);
          }}
          sampleFileUrl="/sample-locations.csv"
        />
      </Drawer>
    </>
  );
};

export default AdminMerchantList;
